import { useCallback, useState } from 'react';

/**
 * The text of a chat turn while it is being written (a copy of
 * screens/systemic-v2/useLiveText.js). Pass `onText` to streamChat; render
 * `text(fields)` in the assistant's bubble while the turn runs; `clear()` when
 * it resolves: the final fields replace it, so the streamed copy is never kept.
 */
export default function useLiveText() {
  const [live, setLive] = useState(null);

  const onText = useCallback((field, delta) => {
    setLive((prev) => ({ ...prev, [field]: (prev?.[field] || '') + delta }));
  }, []);

  const clear = useCallback(() => setLive(null), []);

  const text = useCallback(
    (fields) => fields.map((f) => live?.[f]).filter(Boolean).join('\n\n'),
    [live],
  );

  return { onText, clear, text };
}
